/**
 * @generated SignedSource<<757ec562f832b66d11fb32a38c885dc5>>
 * @relayHash d26dfa39d5ac6967bd377fed8202a736
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0137140aa1ace0794382e91b28c19b7121f05b02839e1b7a8f5b326f6753f7fc

import type { ConcreteRequest, Query } from 'relay-runtime';
export type contentGapTableQuery$variables = {
  cloudId: string;
  helpCenterAri: string;
};
export type contentGapTableQuery$data = {
  readonly helpCenter: {
    readonly helpCenterReportingById: {
      readonly __typename: "HelpCenterReporting";
      readonly contentGapIndicatorsWithMetaData: {
        readonly contentGapIndicators: ReadonlyArray<{
          readonly keywords: string;
          readonly questionsCount: number;
        }> | null | undefined;
      } | null | undefined;
    } | {
      readonly __typename: "QueryError";
      readonly message: string | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type contentGapTableQuery = {
  response: contentGapTableQuery$data;
  variables: contentGapTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      }
    ],
    "concreteType": "HelpCenterQueryApi",
    "kind": "LinkedField",
    "name": "helpCenter",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "helpCenterAri",
            "variableName": "helpCenterAri"
          }
        ],
        "kind": "LinkedField",
        "name": "helpCenterReportingById",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "concreteType": "HelpCenterContentGapIndicatorsWithMetaData",
                "kind": "LinkedField",
                "name": "contentGapIndicatorsWithMetaData",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "HelpCenterContentGapIndicator",
                    "kind": "LinkedField",
                    "name": "contentGapIndicators",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "keywords"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "questionsCount"
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "HelpCenterReporting"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ],
            "type": "QueryError"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "contentGapTableQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "contentGapTableQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "0137140aa1ace0794382e91b28c19b7121f05b02839e1b7a8f5b326f6753f7fc",
    "metadata": {},
    "name": "contentGapTableQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "70c83cc3bb69a172264b4f85b5056a52";

export default node;
